import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { AuthService } from 'src/app/providers/auth.service';
import { TranslateServiceService } from 'src/app/providers/translate-service.service';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sm-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  searchKey: any = '';
  @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  selectedLanguage : any = (localStorage.getItem('appLanguage')) ? localStorage.getItem('appLanguage') : 'en';
  selectLanguage : any;
  apisub:Subscription
  notificationMessageCountData:any
  constructor(private _authService: AuthService, private translateservice: TranslateServiceService, private router: Router, private _modelRef: MatDialog,private apiservice:ApiService) {

    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_MESSAGE_NOTIFICATION_STATUS){
        if(resdata.result){
          this.notificationMessageCountData = resdata.result
        }
      }
    })

   }

  ngOnInit(): void {
    if(this.selectedLanguage == 'en'){
      this.selectLanguage= 'English';
    }else if(this.selectedLanguage == 'hi'){
      this.selectLanguage = 'हिंदी';
    }else if(this.selectedLanguage == 'bn'){
      this.selectLanguage = 'Bengali';
    }
    else{
      this.selectLanguage = 'English';
    }
    console.log(this.selectLanguage);
    
    if(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) != 'null'){
      this.apiservice.getMessageNotificationStatus()

    }
  
  }

  createNewBooking(){
    this.router.navigate(['/new-booking'])
  }
  createNewBill(){
    this.router.navigate(['/produce-bill'])
  }

  openrecharge(){
    this.router.navigate(['/my-recharges']);
  }

  openemaployeeprofile(){
    this.router.navigate(['/employees-profile']);

  }

  

  createNewBusiness(){
    // this._modelRef.open(CreateNewBusinessComponent, {
    //   width: '500px',
    //   data: {
    //     title: 'Create Business',
    //     ref: this._modelRef
    //   },
    // });
    this.router.navigate(['purchased-plan']);
}

  toggleSidebar(){
    this.onToggle.emit(true);
  }
  
  openmessages(){
    this.router.navigate(['messages']);
  }

  opennotification(){
    this.router.navigate(['notifications']);

  }

  signOut(){

    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : 'Are you sure you want to logout?',
        okbtn : 'Confirm',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe((result:any)=>{
      console.log(result);
      if(result){ 
        this._authService.onSignOut();
      }

    });

    
    
  }
  setLanguage(string:any){
    if(string == 'en'){
      this.selectLanguage= 'English';
    }else if(string == 'hi'){
      this.selectLanguage = 'हिंदी';
    }else if(string == 'bn'){
      this.selectLanguage = 'Bengali';
    }
    this.translateservice.useLanguage(string);
  }

  openProfile(){
    this.router.navigate(["/owner-profile"]);
  }
  openbusinessprofile(){
    this.router.navigate(["/business-profile"]);
  }
  openChangeNumber(){
    this.router.navigate(["/phone-number-change"]);
  }
  openPrivacySettings(){
    this.router.navigate(["/privacy-settings"]);
  }
  search(){
    if (
      (this.searchKey) &&
      !this.isSearchDisabled() &&
      !this.isComma()
    ) {
    let qp :any = {}
    if(this.searchKey && this.searchKey != '')
      qp.sk = this.searchKey
    let url = environment.base_lookzup_market_website_url + '/search?sk=' + this.searchKey
    window.open(url, '_blank');
    }
  }

  isSearchDisabled(): boolean {
    return this.searchKey.trim() === '';
  }
  isComma(): boolean {
    const isKeywordCommasOnly = /^(,\s*)+$/.test(this.searchKey.trim());

    return isKeywordCommasOnly;
  }
}
